import { LAYOUTS, } from "@voltmoney/types";
import { CreditLoadingPageType, WIDGET } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { helpAction, onLoad } from "./actions";
export const template = (height) => ({
    layout: {
        id: ROUTE.CHECK_CUSTOMER_ELIGIBILITY,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'waitingScreen',
                type: WIDGET.CREDIT_LOADING_SCREEN,
            },
        ],
    },
    datastore: {
        waitingScreen: {
            height: height,
            type: CreditLoadingPageType.CHECK_ELIGIBILITY,
            helpAction: {
                type: ACTION.HELP_ACTION,
                routeId: ROUTE.CHECK_CUSTOMER_ELIGIBILITY,
                payload: {}
            },
        }
    },
});
export const checkCustomerEligiblityMF = {
    onLoad: async ({ getHeight }) => {
        return Promise.resolve(template(getHeight()));
    },
    action: {
        routeId: ROUTE.CHECK_CUSTOMER_ELIGIBILITY,
        type: ACTION.ON_LOAD,
        payload: {}
    },
    actions: {
        [ACTION.ON_LOAD]: onLoad,
        [ACTION.HELP_ACTION]: helpAction,
    },
};
